module.exports = __webpack_public_path__ + "static/favicon-d2eab68af10dc7890b892c4f39f8452e.ico";